import {
  Box,
  CircularProgress,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { Estado } from "./estadoMunType";
import { useEffect, useRef, useState } from "react";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog } from "../modals";

interface TableEstadosProps {
  initialEstado?: Estado;
  removeOption?: boolean;
  onChoose?: (estado?: Estado) => void;
}

export const ChooseEstado: React.FC<TableEstadosProps> = ({
  initialEstado,
  removeOption,
  onChoose,
}) => {
  const api = useApi();

  const [estado, setEstado] = useState<Estado | undefined>(initialEstado);
  const [estados, setEstados] = useState<Estado[] | RequestError | undefined>();
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => { api.estadosMunicipios.getEstados().then(setEstados); }, []);

  if (!estados) {
    return <Box sx={{
      flex: 1,
      width: "46px",
      height: "46px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <CircularProgress />
    </Box>;
  }

  if ("error" in estados) {
    return <ErrorOnDialog
      open={true}
      error={estados.error}
      message={estados.message}
      onClose={() => setEstados(undefined)}
    />;
  }

  return <div ref={buttonRef} style={{ flex: 1 }}>
    <Select<string>
      value={estado?.sigla ?? "N/A"}
      label={"Escolha um Estado"}
      onChange={(value) => {
        const sigla = value.target.value;

        const estado = estados.filter((val) => val.sigla === sigla)[0];
        setEstado(estado ?? "N/A");
        if (onChoose) onChoose(estado);
      }}
    >
      {removeOption && <MenuItem
        key={"AA"}
        value={"N/A"}>
        <ListItemText>Escolha um Estado</ListItemText>
      </MenuItem>}

      {estados.map((val, i) => {
        return <MenuItem
          key={i}
          value={val.sigla}>
          <ListItemText>{val.sigla + " - " + val.nome}</ListItemText>
        </MenuItem>;
      })}
    </Select>
  </div>;
};